import React, { Component } from 'react';
import { Route, withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import { find, get, debounce } from 'lodash';
import { Link } from 'react-router-dom';
//import ComparisonDetails from './Details';
import ComparisonRows from './ComparisonRows';
import sample from './sample.json';
import IncomeChart from '../../components/pages/comparison/IncomeChart';
import SearchWidget from '../../components/pages/home/SearchWidget';

class ComparisonList extends Component {
	constructor(props) {
		super(props);
		const months = get(props.filter, 'global.monthsSinceRelease', 1);
		const entities = [];
		
		this.state = {
			months,
			baseEntity: null,
			entities
		};
		
	}
	
	pendingAdds = 0;
	
	addEntity = (entity) => {
		let { entities, months, baseEntity } = this.state;
		entity = this.formatEntity(entity, months);
		if(find(entities, e=>(e.id == entity.id && e.entity == entity.entity))) {
			alert('This entity is already selected for comparison, please choose another one.');
			return;
		}
		if(baseEntity && baseEntity != entity.entity) {
			alert('Only entities of the same type can be compared.');
			return;
		}

		this.setState({
			entities: [...entities, entity],
			baseEntity: entity.entity
		})
	}

	/*
	addAnother = () => {
		let { entities, months, baseEntity } = this.state;
		const newEntity = this.formatEntity(sample[entities.length], months);
		
		this.setState({
			entities: [...entities, newEntity],
			baseEntity: newEntity.entity
		})
	}
	*/
	
	debouncedAdd = debounce(() => {
		const numToAdd = this.pendingAdds;
		this.pendingAdds = 0; // reset immediately
	
		if (numToAdd === 0) return;
	
		this.setState((prevState) => {
		  const { entities, months } = prevState;
		  let newEntities = [...entities];
	
		  // Pool all the new entities in one go (using the correct sample index each time)
		  for (let i = 0; i < numToAdd; i++) {
			const newEntity = this.formatEntity(sample[newEntities.length], months);
			newEntities.push(newEntity);
		  }
	
		  return {
			entities: newEntities,
			// baseEntity stays untouched (you said it's constant "tracks")
		  };
		});
	}, 1000); // 1 second after the *last* click
	
	// Replace your original addAnother with this tiny wrapper
	addAnother = () => {
		this.pendingAdds += 1;           // accumulate every rapid click
		this.debouncedAdd();             // schedule (or reschedule) the batch update
	};
	
	componentWillUnmount() {
		this.debouncedAdd.cancel();
	}
	
	deleteEntity = (id, type) => {
		let { entities, baseEntity } = this.state;
		entities = entities.filter(e=>(e.id !== id));
		baseEntity = entities.length > 0 ? baseEntity : null; // reset type filter when there are no selected elements
		this.setState({
			entities,
			baseEntity
		})
	}
	
	formatEntity = (entity, months) => {
		const { code, entity: entity_type, first_released, name } = entity;
		const dateStart = moment(first_released).endOf('month');
		const dateEnd = dateStart.clone().add(months, 'months').endOf('month');
		
		return {
			id: code,
			entity: entity_type,
			title: name,
			dateStart: dateStart.format('YYYY-MM-DD'),
			dateEnd: dateEnd.format('YYYY-MM-DD')		
		}
	}


	componentDidMount(){
	}
	


	componentWillUnmount() {
	}
	
	componentDidUpdate(prevProps) {
		const prevMonths = get(prevProps.filter, 'global.monthsSinceRelease');
		const nextMonths = get(this.props.filter, 'global.monthsSinceRelease');
		if(prevMonths && prevMonths != nextMonths){
			let { entities } = this.state;
			
			this.setState({
				entities: []
			}, ()=>{
				entities = entities.map(e=>{
					const dateEnd = moment(e.dateStart).add(nextMonths, 'months').endOf('month');
					return {
						...e,
						dateEnd: dateEnd.format('YYYY-MM-DD')
					};
				})
				console.log(entities);
				this.setState({
					months: nextMonths,
					entities
				})
			})
		}
	}
	
	renderSearchBox() {
		const { baseEntity } = this.state;
		const entityTypes = baseEntity ? [baseEntity] : ['projects', 'products', 'tracks'];
		const placeholder = `Search ${entityTypes.join(', ')}...`
		return <SearchWidget searchResult={this.addEntity} placeholder={placeholder} entityTypes={entityTypes} baseEntity mode="playlist" />
	}
	
	renderEntities(entities){
		if(!Array.isArray(entities) || !entities.length)
			return null;
		const type = this.state.baseEntity;
		return <div key={`${type}`}>
			<div className="tag-list">
				<div className="page-filter-item">
					<div className="page-filter-list">
						{entities.map((entity, i) =><div key={entity.id} className="comparison-entity-item">
							<span className="comparison-entity-name">Entity #{i + 1}</span>
							<div className={`page-filter ${entity.entity}`}>
								<div className="tag">
									<div className="tag-name-holder">
										<div className="tag-name">
											<span>{entity.title}</span>
										</div>
										<a
											className="close-link"
											onClick={()=>this.deleteEntity(entity.id, type)}
										>
											&times;
										</a>
									</div>
								</div>
							</div>
							</div>)}
					</div>
				</div>
			</div>
		</div>

	}

	
	render() {
		const { entities = [] } = this.state;
		const comparisonSearchClass = `${entities.length > 2 ? 'more-comparison-items' : ''}`;
		return <div className="wrapper wrapper-content">
			<div className='container'>
				<div className="comparison-title-container">
					<h2 className="main-title main-title--mb">Comparison
						<div className="report-warning">These reports are for analytical purposes only and should not be used to pay artist royalties
						</div>
					</h2>
				</div>
			</div>
			<div className="container">
				<div className="comparison-search-container">
					<button type="button" className="default-btn comparison-search-btn" onClick={this.addAnother}>Quick Add</button>
					{this.renderSearchBox()}
					{this.renderEntities(entities)}
				</div>
			</div>
			
			{entities.length > 0 && <div className="todo">
				<IncomeChart entities={entities} />
			</div>}
			
			{/*
			<div className="comparison-wrapper">
				{entities.map(entity=><ComparisonDetails key={entity.id} entity={entity} />)}
			</div>
			*/}
			
			<div className={comparisonSearchClass}>
				<ComparisonRows entities={entities} />
			</div>
			
		</div>

	}
	
}

function mapStateToProps(state) {
	return {
		filter: state.filter
	}
}


export default withRouter(connect(mapStateToProps)(ComparisonList));